const storageKey = 'godismydayone:wishlist';

function savedProducts() {
  try {
    const items = JSON.parse(localStorage.getItem(storageKey));
    return Array.isArray(items) ? items.filter(item =>
      item && typeof item.id === 'string' && typeof item.title === 'string' &&
      typeof item.url === 'string' && /^\/(?![\/\\])/.test(item.url)
    ) : [];
  } catch {
    return [];
  }
}

function syncHearts(items) {
  const ids = new Set(items.map(item => item.id));
  document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
    button.setAttribute('aria-pressed', String(ids.has(button.dataset.wishlistToggle)));
  });
}

function renderWishlist(items) {
  const page = document.querySelector('[data-wishlist-page]');
  if (!page) return;

  page.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
  page.querySelector('[data-wishlist-items]').replaceChildren(...items.map(item => {
    const row = document.createElement('li');
    const link = document.createElement('a');
    link.href = item.url;
    if (typeof item.image === 'string' && /^(https:\/\/|\/\/)/.test(item.image)) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      link.append(image);
    }
    link.append(item.title);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'link';
    remove.textContent = 'Remove';
    remove.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
    remove.dataset.wishlistRemove = item.id;
    row.append(link, remove);
    return row;
  }));
}

document.addEventListener('click', event => {
  const button = event.target.closest('[data-wishlist-toggle], [data-wishlist-remove]');
  if (!button) return;

  const { wishlistToggle, wishlistRemove, wishlistTitle, wishlistUrl, wishlistImage } = button.dataset;
  const id = wishlistToggle || wishlistRemove;
  const items = savedProducts();
  const next = wishlistRemove || items.some(item => item.id === id)
    ? items.filter(item => item.id !== id)
    : [...items, { id, title: wishlistTitle, url: wishlistUrl, image: wishlistImage }];

  try {
    localStorage.setItem(storageKey, JSON.stringify(next));
  } catch {
    const error = document.querySelector('[data-wishlist-error]');
    const message = 'Your browser could not save the wishlist.';
    if (error) error.textContent = message;
    else window.alert(message);
    return;
  }

  syncHearts(next);
  renderWishlist(next);
  if (wishlistRemove) {
    (document.querySelector('[data-wishlist-remove]') ||
      document.querySelector('[data-wishlist-page] h1'))?.focus();
  }
});

function refresh() {
  const items = savedProducts();
  syncHearts(items);
  renderWishlist(items);
}

window.addEventListener('storage', event => {
  if (event.key === storageKey || event.key === null) refresh();
});

new MutationObserver(records => {
  if (records.some(record => [...record.addedNodes].some(node =>
    node.nodeType === Node.ELEMENT_NODE &&
    (node.matches('[data-wishlist-toggle]') || node.querySelector('[data-wishlist-toggle]'))
  ))) syncHearts(savedProducts());
}).observe(document.body, { childList: true, subtree: true });

refresh();
